<template>
    <div ref="container">
        <zm-row>
            <zm-button size="small" @click="showCreateUser()" class="btn-in-line" type="primary" v-if="role === 'SUPER_ADMIN'">create user</zm-button>
            <zm-button size="small" @click="showAll()" plain class="btn-in-line">show all user</zm-button>
            <zm-button size="small" plain @click="downloadUsers" style="margin-left: 8px;" v-if="hasPermission">download all</zm-button>
            <zm-upload
                class="upload-demo"
                v-if="hasPermission"
                :action="getUserAction()"
                id="upload"
                :headers="headers"
                :on-progress="onProgress"
                :on-success="onSuccess"
                :on-error="onError"
                :show-file-list="false"
                :disabled="loading"
                :file-list="fileList">
                <zm-button plain class="btn-right" :loading="importLoading">import</zm-button>
            </zm-upload>
            <!-- <zm-input size="small" placeholder="user name" v-model="search" class="search-input">
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="searchByName()"></zm-button>
            </zm-input> -->
            <zm-input size="small" placeholder="search" v-model.trim="search" class="search-input" @keyup.enter.native="doSearch()">
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="doSearch()"></zm-button>
            </zm-input>
            <zm-select size="small" v-model="select" class="search-select">
                <zm-option option-id="1" label="name" value="name"></zm-option>
                <zm-option option-id="2" label="id" value="id"></zm-option>
            </zm-select>
        </zm-row>
        <div class="table-container">
            <zm-table :data="list" resizable border @sort-change="onSort" :init-displayed-column="initDisplayedColumn"
            v-loading="loading" :default-sort="{prop: 'modifiedTime', order: 'descending'}" :row-class-name="tableRowClassName">
                <zm-table-column prop="role" label="role" width="150px" align="center"
                    :filters="[{ text: 'SUPER_ADMIN', value: 'SUPER_ADMIN' }, { text: 'ADMIN', value: 'ADMIN' }, { text: 'APP', value: 'APP' }, { text: 'REVIEWER', value: 'REVIEWER' }, { text: 'DEVELOPER', value: 'DEVELOPER' }, { text: 'READONLY', value: 'READONLY' }]"
                    :filter-method="filterRole"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <zm-tag size="small" v-if="scope.row.role === 'APP'" type="">APP</zm-tag>
                        <zm-tag size="small" v-if="scope.row.role === 'ADMIN'" type="success">ADMIN</zm-tag>
                        <zm-tag size="small" v-if="scope.row.role === 'SUPER_ADMIN'" type="danger">SUPER_ADMIN</zm-tag>
                        <zm-tag size="small" v-if="scope.row.role === 'REVIEWER'" type="info">REVIEWER</zm-tag>
                        <zm-tag size="small" v-if="scope.row.role === 'DEVELOPER'" type="info">DEVELOPER</zm-tag>
                        <zm-tag size="small" v-if="scope.row.role === 'READONLY'" type="info">READONLY</zm-tag>
                    </template>
                </zm-table-column>
                <zm-table-column prop="name" label="name" align="center" :show-overflow-tooltip="true" sortable>
                </zm-table-column>
                <zm-table-column prop="emails" label="emails" align="center" :show-overflow-tooltip="true" sortable>
                </zm-table-column>
                <zm-table-column prop="createdTime" label="createdTime" align="center" :formatter="setTime" :show-overflow-tooltip="true" sortable>
                </zm-table-column>
                <zm-table-column prop="lastSecurityResetTime" label="lastSecurityResetTime" align="center" :formatter="setTime" width="210px" :show-overflow-tooltip="true" sortable>
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" align="center" :formatter="setTime" :show-overflow-tooltip="true" sortable>
                </zm-table-column>
                <zm-table-column prop="operate" label="operate" header-align="center" width="180px" v-if="hasPermission">
                    <template slot-scope="scope">
                        <zm-button size="small" class="btn-contain" type="icon" title="edit user" icon="zm-icon-edit" @click="getUserAssociation(scope.row, 'showEditUser')" v-if="hasPermission"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="enable user" icon="zm-icon-play" v-if="!scope.row.active && hasPermission" @click="activeUser(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="disable user" icon="zm-icon-pause" v-if="scope.row.active && hasPermission" @click="activeUser(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="delete user" icon="zm-icon-delete" @click="getUserAssociation(scope.row, 'deleteUser')"
                        v-show="(role === 'SUPER_ADMIN' && !scope.row.active) || (role === 'ADMIN' && scope.row.role !== 'SUPER_ADMIN' && !scope.row.active)"></zm-button>
                        <zm-dropdown class="btn-contain" @command="handleCommand" trigger="click">
                            <zm-button type="icon" icon="zm-icon-more" class="btn-contain" :loading="scope.row.loading"></zm-button>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item v-if="hasPermission"
                                    :command="{command: 'resetSecret', param: scope.row}">
                                    Reset User Secret
                                </zm-dropdown-item>
                                <zm-dropdown-item
                                    :command="{command: 'showGroup', param: scope.row.name}">
                                    Show Producer Group
                                </zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="paginationChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    :page-size="pageable.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible" label-position="left" :rules="rules" ref="form">
            <zm-form :model="form" label-position="left" :rules="rules" ref="form">
                <zm-form-item label="name" :label-width="formLabelWidth" prop="name">
                    <div slot="label">
                        <tip label="name" id="user-name"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.name" :disabled="form.title === 'Edit User' && form.name.indexOf('@zoom.us') !== -1"></zm-input>
                </zm-form-item>
                <zm-form-item label="role" :label-width="formLabelWidth" prop="role">
                    <div slot="label">
                        <tip label="role" id="user-role"></tip>
                    </div>
                    <zm-select size="small" v-model="form.role">
                        <zm-option label="ADMIN" value="ADMIN" v-if="role !== 'APP'"></zm-option>
                        <zm-option label="APP" value="APP"></zm-option>
                        <zm-option label="REVIEWER" value="REVIEWER"></zm-option>
                        <zm-option label="DEVELOPER" value="DEVELOPER"></zm-option>
                        <zm-option label="READONLY" value="READONLY"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="emails" :label-width="formLabelWidth" prop="emails">
                    <div slot="label">
                        <tip label="emails" id="user-emails"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.emails" placeholder="san.zhang@zoom.us,si.li@zoom.us,"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enableAlert">
                        <tip label="enable alert" id="user-enableAlert"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enableReport">
                        <tip label="enable report" id="user-enableReport"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="description" :label-width="formLabelWidth" prop="description">
                    <div slot="label">
                        <tip label="description" id="user-description"></tip>
                    </div>
                    <zm-input size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 4}" v-model="form.description"></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.active">
                        <tip label="active" id="user-active"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="webhookChannel" :label-width="formLabelWidth">
                    <div slot="label">
                        <tip label="webhookChannel" id="user-webhookChannel"></tip>
                    </div>
                    <zm-select multiple size="small" v-model="form.webhookChannelIds" :checkbox-options="webhookList">
                    </zm-select>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="New Secret" :visible.sync="showSecret" ref="newsecretdialog">
            <span>New password is: &nbsp;</span>
            <input id="textCopy1" v-show="true" class="zm-input__inner secret-input" readonly/>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="showSecret = false">OK</zm-button>
                <button type="button" id="copybutton2" class="zm-button zm-button--primary"
                    ref="copy1"
                    @click="handleCopy1"
                    data-clipboard-action="copy"
                    data-clipboard-target="#textCopy1"
                    v-show="true">Copy and Close</button>
            </div>
        </zm-dialog>
        <zm-dialog title="New User" :visible.sync="showNewApp">
            <p>User name is: {{ name }}</p>
            <span>Password is:  &nbsp;</span>
            <input id="textCopy2" v-show="true" class="zm-input__inner secret-input" readonly/>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="showNewApp = false">OK</zm-button>
                <button type="button" id="copybutton3" class="zm-button zm-button--primary"
                    ref="copy2"
                    @click="handleCopy2"
                    data-clipboard-action="copy"
                    data-clipboard-target="#textCopy2"
                    v-show="true">Copy and Close</button>
            </div>
        </zm-dialog>
        <zm-dialog title="Import Failed Result" :visible.sync="resultVisible" show-close>
            <div class="table-container">
                <zm-table :data="resultList">
                    <zm-table-column type="index" width="50"></zm-table-column>
                    <zm-table-column prop="result" label="Failed Message"></zm-table-column>
                </zm-table>
            </div>
        </zm-dialog>
        <zm-dialog title="User Association" :visible.sync="associationVisible" show-close>
            <zm-form v-if="methodType === 'resetSecret'">
                <zm-form-item label="Reset Type">
                   <zm-select v-model="resetType">
                        <zm-option v-for="item in resetTypeList" :key="item" :label="item" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
            </zm-form>
            <div class="table-container">
                <zm-tabs v-model="activeTab">
                    <zm-tab-pane label="Association Produce Topics" name="associationProduceTopics">
                        <zm-table :data="associationData.associationProduceTopics">
                            <zm-table-column prop="topicName" label="topicName"></zm-table-column>
                            <zm-table-column prop="workingInstances" label="workingInstances"></zm-table-column>
                        </zm-table>
                    </zm-tab-pane>
                    <zm-tab-pane label="Association Subscribe Topics" name="associationSubscribeTopics">
                        <zm-table :data="associationData.associationSubscribeTopics">
                            <zm-table-column prop="topicName" label="topicName"></zm-table-column>
                            <zm-table-column prop="groupName" label="groupName"></zm-table-column>
                            <zm-table-column prop="workingInstances" label="workingInstances"></zm-table-column>
                        </zm-table>
                    </zm-tab-pane>
                    <zm-tab-pane label="Association User Infos" name="associationUserInfos">
                        <zm-collapse v-model="activeCollapses" v-if="associationData.associationUserInfos">
                            <zm-collapse-item v-for="(item, index) in associationData.associationUserInfos" :key="index"
                                :title="item.userName + ': ' + item.secretType" :name="index">
                                <zm-tabs v-model="activeUserTab">
                                    <zm-tab-pane label="Association Produce Topics" name="associationProduceTopics">
                                        <zm-table v-if="item.associationProduceTopics" :data="item.associationProduceTopics">
                                            <zm-table-column prop="topicName" label="topicName"></zm-table-column>
                                            <zm-table-column prop="workingInstances" label="workingInstances"></zm-table-column>
                                        </zm-table>
                                    </zm-tab-pane>
                                    <zm-tab-pane label="Association Subscribe Topics" name="associationSubscribeTopics">
                                        <zm-table v-if="item.associationSubscribeTopics" :data="item.associationSubscribeTopics">
                                            <zm-table-column prop="topicName" label="topicName"></zm-table-column>
                                            <zm-table-column prop="groupName" label="groupName"></zm-table-column>
                                            <zm-table-column prop="workingInstances" label="workingInstances"></zm-table-column>
                                        </zm-table>
                                    </zm-tab-pane>
                                </zm-tabs>
                            </zm-collapse-item>
                        </zm-collapse>
                    </zm-tab-pane>
                </zm-tabs>
            </div>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="associationVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="resetSecret(associationRow)" :loading="loading" v-if="methodType === 'resetSecret'">Reset Secret</zm-button>
                <zm-button size="small" type="primary" @click="doActive(associationRow)" :loading="loading" v-if="methodType === 'doActive'">Active User</zm-button>
                <zm-button size="small" type="primary" @click="showEditUser(associationRow)" :loading="loading" v-if="methodType === 'showEditUser'">Edit User</zm-button>
                <zm-button size="small" type="primary" @click="deleteUser(associationRow.id)" :loading="loading" v-if="methodType === 'deleteUser'">Delete User</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getUserList, createUser, updateUser, deleteUser,
getUserListById,
getUserAssociation,
downloadUsers,
getUserListByName, resetUserSecret, activeUser } from '../../api/index'
import { listWebhook } from '@/api/webhook'
import Clipboard from 'clipboard'
import tip from 'components/ToolTip/index'
export default {
    name: 'user',
    components: {
        tip
    },
    data () {
        var validateName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter name'))
            } else {
                var arr = ['&', '\\', '/', '*', '>', '<', '!']
                var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/
                if (!reg.test(value)) {
                    for (var i = 0; i < arr.length; i++) {
                        for (var j = 0; j < value.length; j++) {
                            if (arr[i] === value.charAt(j)) {
                                callback(new Error('invalid name!'))
                            }
                        }
                    }
                    if (this.form.title === 'Create User') {
                        this.list.filter(data => {
                            if (data.name === value) {
                                callback(new Error('name already exists!'))
                            }
                        })
                    }
                    callback()
                }
                callback(new Error('invalid name!'))
            }
        }
        var validateEmail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter email'))
            } else {
                const emails = value.split(',')
                for (var item in emails) {
                    var apos = emails[item].indexOf('@')
                    var lastapos = emails[item].lastIndexOf('@')
                    var dotpos = emails[item].lastIndexOf('.')
                    if ((apos < 1 || dotpos - apos < 2 || apos !== lastapos) && emails[item] !== '') {
                        callback(new Error('invalid emails!'))
                    }
                }
                callback()
            }
        }
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'user',
                props: ['role', 'name', 'emails', 'createdTime', 'lastSecurityResetTime', 'modifiedTime', 'operate']
            },
            list: [],
            listBy: 0,
            role: localStorage.role,
            loading: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            dialogFormVisible: false,
            webhookList: [],
            form: {
                title: '',
                id: '',
                emails: '',
                role: '',
                active: true,
                enableAlert: false,
                enableReport: false,
                name: '',
                webhookChannelIds: [],
                description: ''
            },
            select: 'name',
            search: '',
            showAllBtn: false,
            formLabelWidth: '120px',
            name: '',
            newSecret: '',
            showSecret: false,
            showNewApp: false,
            rules: {
                name: [
                    { required: true, validator: validateName, trigger: 'blur' }
                ],
                role: [
                    { required: true, message: 'please enter role', trigger: 'blur' }
                ],
                emails: [
                    { required: true, validator: validateEmail, trigger: 'blur' }
                ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ]
            },
            resultList: [],
            resultVisible: false,
            fileList: [],
            importLoading: false,
            methodType: '',
            associationData: {},
            associationVisible: false,
            activeTab: 'associationProduceTopics',
            activeCollapses: '0',
            activeUserTab: 'associationProduceTopics',
            associationRow: {},
            resetType: 'RESET_SECRET',
            resetTypeList: ['RESET_SECRET', 'RETAIN_CURRENT_SECRET', 'REVOKE_RETAINED_SECRET', 'RESET_CURRENT_SECRET'],
            headers: {
                Authorization: 'Bearer ' + localStorage.token
            }
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.listBy = JSON.parse(localStorage.params).listBy
            this.select = JSON.parse(localStorage.params).select
            this.search = JSON.parse(localStorage.params).search
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        if (this.listBy) {
            this.doSearch()
        } else {
            this.fetchData()
        }
    },
    computed: {
        // tableData () {
        //     if (this.search) {
        //         return this.list.filter(data => {
        //             return Object.keys(data).some(key => {
        //                 return String(data[key]).toLowerCase().indexOf(this.search) > -1
        //             })
        //         })
        //     }
        //     return this.list
        // }
    },
    watch: {
        listBy () {
            this.setURL()
        },
        select () {
            this.setURL()
        },
        search () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        getUserAction () {
            return process.env.VUE_APP_API_URL + 'api/v1/user/information/import'
        },
        onProgress () {
            this.importLoading = true
        },
        onSuccess (res, file) {
            this.$message.success('Upload file success')
            this.importLoading = false
            if (res.body.length) {
                this.resultList = res.body.map(item => {
                    return {
                        result: item
                    }
                })
                this.resultVisible = true
            }
        },
        onError (err, file) {
            this.$message({
                type: 'error',
                message: err.response.data.errorMessage
            })
        },
        setURL () {
            const { listBy, select, search } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, listBy, select, search, page, size }
            localStorage.params = JSON.stringify(data)
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
            if (a[prop] > b[prop]) {
                return descending ? -1 : 1
            } else if (a[prop] < b[prop]) {
                return descending ? 1 : -1
            } else {
                return 0
            }
            })
        },
        setTime (row, column, cellValue, index) {
            if (cellValue) {
                let time = row[column.property]
                return new Date(parseInt(time)).toLocaleString()
                // return cellValue.split('T')[0] + ' ' + cellValue.split('T')[1].split('.')[0]
            } else {
                return '--'
            }
        },
        paginationChange () {
            if (this.listBy) {
                if (this.select === 'name') {
                    this.searchByName()
                } else {
                    this.searchById()
                }
            } else {
               this.fetchData()
            }
        },
        showAll () {
            this.listBy = 0
            this.fetchData()
        },
        doSearch () {
            if (this.select === 'name') {
                this.searchByName()
            } else {
                this.searchById()
            }
        },
        searchById () {
            if (this.search !== '') {
                this.loading = true
                this.listBy = 1
                getUserListById(this.search).then(response => {
                    this.list = []
                    this.list.push(response)
                    this.pageable.total = 1
                    this.pageable.page = 1
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message({
                    message: 'Please input user id!',
                    type: 'warning'
                })
            }
        },
        searchByName () {
            // const {pageable:{page, size}} = this.pageable
            if (this.search !== '') {
                this.loading = true
                this.listBy = 1
                getUserListByName(this.search, this.pageable.size, this.pageable.page - 1).then(response => {
                    const { content, pageable: { page, size }, total } = response
                    this.list = content
                    this.pageable.total = total
                    this.pageable.page = page + 1
                    this.pageable.size = size
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message({
                    message: 'Please input user name!',
                    type: 'warning'
                })
            }
        },
        copySecret () {
            this.$nextTick(() => {
                this.doCopySecret()
            })
        },
        handleCopy1 () {
            var input = document.getElementById('textCopy1')
            input.value = this.newSecret
            this.$nextTick(() => {
                  const copybtn = this.$refs.copy1
                  this.clipboard = new Clipboard(copybtn)
                  this.showSecret = false
            })
        },
        handleCopy2 () {
            var input = document.getElementById('textCopy2')
            input.value = this.newSecret
            this.$nextTick(() => {
                  const copybtn = this.$refs.copy2
                  this.clipboard = new Clipboard(copybtn)
                  this.showNewApp = false
            })
        },
        doCopySecret () {
            // const secret = this.newSecret
            // var button = document.getElementById('copybutton')
            // button.click()
            // input.value = secret
            // input.select()
            document.execCommand('copy')
            // const copyBtn = new this.$clipboard(this.$refs.copy)
            // copyBtn.on('success', function () {
            //     copyBtn.destroy()
            // })
            // copyBtn.on('error', function () {
            //     copyBtn.destroy()
            // })
            setTimeout(() => {
                var button = document.getElementById('copybutton2')
                button.click()
                // this.$nextTick(() => {
            // this.$copyText(secret).then(e => {
                // this.$message({
                //     message: 'New secret has been copied!',
                //     type: 'success'
                // })
            // }, err => {
            // })
            // })
            }, 6000)
        },
        filterRole (value, row) {
            return row.role === value
        },
        tableRowClassName ({ row, rowIndex }) {
            if (!row.active) {
                return 'warning-row'
            }
            return ''
        },
        fetchData () {
            this.showAllBtn = false
            this.loading = true
            getUserList(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        getUserAssociation (row, methodType) {
            this.methodType = methodType
            this.associationRow = row
            getUserAssociation(row.id).then(response => {
                if (response) {
                    this.associationData = response
                    this.associationVisible = true
                } else {
                    this.loading = true
                    const h = this.$createElement
                    this.$msgbox({
                        title: 'Warning',
                        message: h('p', null, [
                            h('b', { style: 'color: #E02828' }, 'The user has associated topic or subscriber in use. Continue?')
                        ]),
                        showCancelButton: true,
                        confirmButtonText: 'Continue',
                        cancelButtonText: 'Cancel',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                if (methodType === 'resetSecret') {
                                    resetUserSecret(row.id, this.resetType).then(response => {
                                        done()
                                        this.newSecret = response.password
                                        this.showSecret = true
                                        this.$nextTick(() => {
                                            var input = document.getElementById('textCopy1')
                                            input.value = response.password
                                            const copybtn = this.$refs.copy1
                                            this.clipboard = new Clipboard(copybtn)
                                        })
                                        this.loading = false
                                    }).catch(() => {
                                        this.loading = false
                                    })
                                } else if (methodType === 'doActive') {
                                    activeUser(row.id, !row.active).then(response => {
                                        done()
                                        this.fetchData()
                                        this.$message({
                                            message: 'Change status success!',
                                            type: 'success'
                                        })
                                    }).catch(() => {
                                        this.loading = false
                                    })
                                } else if (methodType === 'showEditUser') {
                                    this.form.title = 'Edit User'
                                    this.form.id = row.id
                                    this.form.name = row.name
                                    this.form.role = row.role
                                    this.form.emails = row.emails
                                    this.form.description = row.description
                                    this.form.enableAlert = row.enableAlert
                                    this.form.enableReport = row.enableReport
                                    this.form.active = row.active
                                    if (!this.webhookList.length) {
                                        listWebhook().then(response => {
                                            response.map(item => {
                                                this.webhookList.push({
                                                    value: item.id,
                                                    label: item.channelName
                                                })
                                            })
                                            this.dialogFormVisible = true
                                            done()
                                        })
                                    } else {
                                        this.dialogFormVisible = true
                                        done()
                                    }
                                    getUserListById(row.id).then(response => {
                                        this.form.webhookChannelIds = response.webhookChannelIds
                                    })
                                } else if (methodType === 'deleteUser') {
                                    this.loading = true
                                    deleteUser(row.id).then(response => {
                                        done()
                                        this.fetchData()
                                        this.$message({
                                            message: 'Delete user success!',
                                            type: 'success'
                                        })
                                    }).catch(() => {
                                        this.loading = false
                                    })
                                }
                            } else {
                                this.loading = false
                                done()
                                this.$message({
                                    type: 'info',
                                    message: 'Operation canceled'
                                })
                            }
                        }
                    })
                }
            })
        },
        resetSecret (row) {
            this.$confirm('This will permanently reset the secret of ' + row.name + '. Continue?', 'Warning', {
                confirmButtonText: 'Reset',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                resetUserSecret(row.id, this.resetType).then(response => {
                    this.associationVisible = false
                    this.newSecret = response.password
                    this.showSecret = true
                    this.$nextTick(() => {
                        var input = document.getElementById('textCopy1')
                        input.value = response.password
                        const copybtn = this.$refs.copy1
                        this.clipboard = new Clipboard(copybtn)
                    })
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Reset canceled'
                })
            })
        },
        doActive (row) {
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                activeUser(row.id, !row.active).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                    this.associationVisible = false
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        activeUser (row) {
            if (row.active) {
                this.getUserAssociation(row, 'doActive')
            } else {
                this.doActive(row)
            }
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.paginationChange()
        },
        showCreateUser () {
            this.form.title = 'Create User'
            this.dialogFormVisible = true
            this.form.name = ''
            this.form.role = 'APP'
            this.form.emails = ''
            this.form.description = ''
            this.form.enableAlert = true
            this.form.enableReport = true
            this.form.active = true
        },
        showEditUser (row) {
            this.associationVisible = false
            this.form.title = 'Edit User'
            this.form.id = row.id
            this.form.name = row.name
            this.form.role = row.role
            this.form.emails = row.emails
            this.form.description = row.description
            this.form.enableAlert = row.enableAlert
            this.form.enableReport = row.enableReport
            this.form.active = row.active
            if (!this.webhookList.length) {
                listWebhook().then(response => {
                    response.map(item => {
                        this.webhookList.push({
                            value: item.id,
                            label: item.channelName
                        })
                    })
                    this.dialogFormVisible = true
                })
            } else {
                this.dialogFormVisible = true
            }
            getUserListById(row.id).then(response => {
                this.form.webhookChannelIds = response.webhookChannelIds
            })
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    var { id, name, emails, role, enableAlert, enableReport, description, active, webhookChannelIds } = this.form
                    const data = { name, emails, role, enableAlert, enableReport, description, active, webhookChannelIds }
                    if (this.form.title === 'Create User') {
                        createUser(data).then(response => {
                            // this.name = response.name
                            // this.newSecret = response.password
                            // debugger
                            // this.copySecret()
                            // activeUser(response.id, active).then(res => {
                            this.pageable.page = 1
                                this.fetchData()
                                this.name = response.name
                                this.newSecret = response.password
                                // this.copySecret()
                                this.showNewApp = true
                                this.$nextTick(() => {
                                    var input = document.getElementById('textCopy2')
                                    input.value = response.password
                                    const copybtn = this.$refs.copy2
                                    this.clipboard = new Clipboard(copybtn)
                                })
                            // }).catch(() => {
                            //     this.loading = false
                            // })
                            // this.$alert('name is: ' + response.name + `/n` + 'password is: ' + response.password, 'Create Success', {
                            //     confirmButtonText: 'OK'
                            // })
                            // this.fetchData()
                            // this.$message({
                            //     message: 'Create user success!',
                            //     type: 'success'
                            // })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (this.form.title === 'Edit User') {
                        updateUser(id, data).then(response => {
                            activeUser(id, active).then(response => {
                                // this.pageable.page = 1
                                this.fetchData()
                            }).catch(() => {
                                this.loading = false
                            })
                            this.$message({
                                message: 'Edit user success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            message: 'error!',
                            type: 'error'
                        })
                    }
                } else {
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        downloadUsers () {
            this.$confirm('This will download all users. Continue?', 'Warning', {
                confirmButtonText: 'Download',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$message.info('Downloading, please wait..')
                downloadUsers().then((res) => {
                    let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                    var a = document.createElement('a')
                    a.href = URL.createObjectURL(blob)
                    a.download = 'asyncmq_all_users_data.xlsx'
                    a.style.display = 'none'
                    document.body.appendChild(a)
                    a.click()
                    a.remove()
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Download canceled'
                })
            })
        },
        handleCommand (command) {
            if (command.command === 'resetSecret') {
                this.getUserAssociation(command.param, 'resetSecret')
            } else if (command.command === 'showGroup') {
                this.$router.push('/dashboard/user/' + command.param)
            }
        },
        deleteUser (id) {
            this.$confirm('This will permanently delete the user. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteUser(id).then(response => {
                    this.associationVisible = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete user success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        }
    }
}
</script>
<style>
.btn-contain.zm-dropdown {
    margin: 8px;
    display: inline;
}
.btn-in-line{
    margin: 10px
}
.zm-input-group{
    width: 20%;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.search-select {
    float: right;
    margin: 10px 0;
    width: 100px;
}
.secret-input {
    width: calc(100% - 130px);
}
.upload-demo {
    display: inline-block;
}
.upload-demo .zm-upload {
    float: left;
    margin-bottom: -11px;
    margin-left: 18px;
}
</style>
